import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

// eslint-disable-next-line import/prefer-default-export
export const routes = {
  approverDeclined: '/approver-declined',
  baseRoute: '/',
  chooseRole: '/choose-role',
  confirmCode: '/confirm-code',
  forgotPassword: '/forgot-password',
  login: '/login',
  regFlow: '/reg',
  verifyDeclined: '/verify-declined',
  verifyHardDeclined: '/verify-hard-declined',
  complete: '/complete',
  needParent: '/need-parent',
  enterDob: '/enter-dob',
  childComplete: '/child-complete',
  choosePlan: '/choose-plan',
  parentInvite: '/parent-invite',
  parentInviteComplete: '/parent-invite-complete'
};

export const nextGenRoutes = {
  onboarding: `${publicRuntimeConfig.onboardingHost}/onboarding`
};
